import React, { Component } from 'react';
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import { config } from '../../Constants';
import axios from 'axios';
import global from '../global';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import queryString from 'query-string';
import Select from 'react-select';
import goBack from '../../Asset/Images/previous-icon.png';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import EasyDebenturesLogo from '../../Asset/Images/easy-dividend-logo.png';
import DebenturesHubLogoWhite from '../../Asset/Images/Debentures Hub logo-white.svg';
import DebenturesHubLogo from '../../Asset/Images/Debentures-Hub-logo.svg';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';


export class OtherResident extends Component {
    static displayName = OtherResident.name;

    constructor(props) {
        super(props);
        this.state = {
            ResidentTypeList: [
                {
                    "value": "1",
                    "label": "LIC"
                },
                {
                    "value": "2",
                    "label": "Mutual Funds"
                },
                {
                    "value": "3",
                    "label": "Others"
                }],
            ResidentTypeID: 0,
            filesToBeSent: [],
            fileExemption: '',
            fileOD1: '',
            fileOD2: '',
            isOthers: 'block',
            isSearchable: true,
            isOpen: false,
            AssignmentCode: ''
        };

        const parsed = queryString.parse(window.location.search);
        this.state.AssignmentCode = parsed['AC'] == undefined ? "" : window.atob(parsed['AC']);
    }

    handleResidentTypeChange = (e) => {
        if (e.value != '') {

            if (e.value == "3") {
                this.setState({
                    ResidentTypeID: e.value,
                    isOthers: "none"
                });
            }
            else {
                this.setState({
                    ResidentTypeID: e.value,
                    isOthers: "block"
                });
            }
        }
    }

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    closeModal = () => {
        this.setState({ isOpen: false })

        window.location.href = config.url.Web_URL + '/';
    };

    handlefileExemption = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileTRC: event.target.files[0] });

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileExemption: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

    };

    handlefileOD1 = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileOD1: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileOD1: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

    };

    handlefileOD2 = event => {
        debugger
        let file = event.target.files[0];

        var filesArray = event.target.files[0];   //this.state.filesToBeSent;

        let form = new FormData();
        var mimeType = filesArray.type;

        this.setState({ fileOD2: event.target.files[0] });

        //form.append("File", filesArray);
        //form.append("fileName", filesArray.name);

        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "pdf" || type == "jpg" || type == "png" || type == "doc" || type == "docx" || type == "msg") {
            this.setState({ fileOD2: event.target.files[0] });
        }
        else {
            event.target.value = null;
            this.showNoti("Notification", global.Message.SpecifiedFormatRequiredMessage, "danger");
        }

    };

    handleUpload = (e) => {
        debugger
        let form = new FormData();

        if (this.state.ResidentTypeID == "" || this.state.ResidentTypeID == null) {
            this.showNoti("Notification", "Resident Type is required.", "danger");
            return;
        }

        if (this.state.fileExemption == "" || this.state.fileExemption == null) {
            this.showNoti("Notification", "Exemption Certificate / Declaration is required.", "danger");
            return;
        }

        form.append("FileExemption", this.state.fileExemption);
        form.append("FileOD1", this.state.fileOD1);
        form.append("FileOD2", this.state.fileOD2);
        form.append("AssignmentCode", this.state.AssignmentCode);
        form.append("ResidentTypeID", this.state.ResidentTypeID);


        axios.post(global.UserManagement.UploadFilesOtherResidentAPI, form)
            .then(response => {
                debugger
                if (response.data.status) {
                    this.setState({ isOpen: true });
                }
                else {
                    this.showNoti("Notification", "Unable to Submit Declaration", "danger");
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleCancel = (e) => {

        e.preventDefault();
        window.location.href = config.url.Web_URL + `/Resident`;
    }

    render() {
        const {
            isSearchable
        } = this.state;

        return (

            <div>
                <ReactNotification />

                <div className="limiter">
                    <div className="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">                            
                            <div className="wrap-login100 m-t-20">
                                <img src={DebenturesHubLogo} alt="Logo" className="logo-img" />
                                <div className="login100-form">
                                    <h3 className="legend last docTitle">Other Resident Documents</h3>

                                    <Row className="w-100 dec_form">
                                        <Col md={12}>
                                            <label className="required-field text-bold">Resident Type</label>
                                            <br />
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="Select Resident Type"
                                                placeholder="Select Resident Type"
                                                value={this.state.ResidentTypeList.find(obj => obj.value === this.state.ResidentTypeID)}
                                                isSearchable={isSearchable}
                                                options={this.state.ResidentTypeList}
                                                onChange={this.handleResidentTypeChange}
                                            />
                                        </Col>
                                        <Col md={12} className="m-t-30" style={{ display: `${this.state.isOthers}` }}>
                                            <label className="required-field text-bold">Exemption Certificate / Declaration</label>
                                            <br />
                                            <input type="file" name="files" id="fileTRC" onChange={this.handlefileExemption} className="m-t-20" />
                                        </Col>
                                        <Col md={6} className="m-t-30">
                                            <label className="text-bold">Other Document 1</label>
                                            <br />
                                            <input type="file" name="files" id="fileOD1" onChange={this.handlefileOD1} className="m-t-20" />
                                        </Col>

                                        <Col md={6} className="m-t-30">
                                            <label className="text-bold">Other Document 2</label>
                                            <br />
                                            <input type="file" name="files" id="fileOD2" onChange={this.handlefileOD2} className="m-t-20" />
                                        </Col>
                                        <Col md={12} className="m-t-20">
                                            <label className="m-t-10 labelNote">Note: Only .pdf, .doc, .jpg, .png & .msg file format are allowed and max size is 3 MB</label>
                                        </Col>

                                        <Col md={12} className="m-t-20">
                                            <button class="btn btn-primary w-100" onClick={this.handleUpload}>
                                                Submit Declaration
                                            </button>
                                        </Col>
                                    </Row>
                                    
                                    <div className="txt1 text-center p-t-20">
                                        <img src={goBack} className="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />

                                    </div>
                                    <div className="txt1 text-center p-t-20" style={{ textAlign: "center" }}>
                                        <span style={{ verticalAlign: "middle" }}>Powered by </span>
                                        <img src={NexdmsmImg} style={{ verticalAlign: "middle" }} />
                                    </div>
                                </div>
                                <Row>
                                    <Modal show={this.state.isOpen} onHide={this.closeModal}>
                                        <Modal.Header closeButton>
                                            <Modal.Title className="modal_title">Notification !</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="modal_body">
                                            Declaration has been submitted successfully
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="dark" onClick={this.closeModal}>
                                                Close
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                </Row>

                                </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}